import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

/**
 * Signs in to firebase using credentials from user object
 * obtained from google sign in
 *
 * @param {Object} googleUser - User object obtained from google sign in
 * @return {Promise} - Promise which gets resolved after the user is signed in to firebase.
 */
export async function signInToFirebase(googleUser) {
  // Build Firebase credential with the Google ID token.
  var credential = firebase.auth.GoogleAuthProvider.credential(
    googleUser.id_token
  );
  // Sign in to firebase with credential from the Google user.
  await firebase.auth().signInWithCredential(credential);
}

/**
 * Logs out the user from firebase
 *
 * @param {function} callback - Callback function to execute after the logout is successful
 */
export async function signOutFromFirebase(callback) {
  firebase
    .auth()
    .signOut()
    .then(function () {
      callback();
    })
    .catch(function (error) {
      console.error("Unable to logout");
      console.error(error);
    });
}

/**
 * Checks equality of google user and firebase user based on providerId and uid.
 *
 * @param {Object} googleUser - User object obtained from google sign in
 * @param {Object} firebaseUser - User object obtained from firebase sign in
 * @return {Boolean} - Whether the google user and firebase user are equal
 */
export function isUserEqual(googleUser, firebaseUser) {
  if (!firebaseUser) {
    return false;
  }

  let { providerData } = firebaseUser;

  let sameProvider = (providerId) =>
    providerId === firebase.auth.GoogleAuthProvider.PROVIDER_ID;
  let sameUid = (uid) => uid === googleUser.profileObj?.sub;

  let sameUser = ({ providerId, uid }) =>
    sameProvider(providerId) && sameUid(uid);

  return providerData.some(sameUser);
}

/**
 * Logs successful login user details to firebase collection
 *
 * @param {Object} user - User object containing email, name and user's uid
 */
export async function addSuccessfulLoginLog(user) {
  let db = firebase.firestore();
  let successfulLoginsCollectionRef = db.collection("successful_logins");

  let successfulLoginsObj = {
    email: user.email,
    logged_in_at: firebase.firestore.FieldValue.serverTimestamp(),
    name: user.name,
    user_id: user.uid,
  };
  await successfulLoginsCollectionRef.add(successfulLoginsObj);
}
